import React from 'react';
import { Calculator } from 'lucide-react';

export const PayrollLoadingState: React.FC = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <Calculator className="h-8 w-8 mx-auto mb-2 animate-spin" />
          <p>Calculating payroll...</p>
        </div>
      </div>
    </div>
  );
};